import { Affix, Button, Card } from "antd";
import {
  COMMERCIAL_PACKING_REQUIREMENTS,
  COMMERCIAL_PACKING_REQUIREMENTS_EDIT,
} from "apiServices/API_ENDPOINTS";
import { getData, postData } from "apiServices/common";
import { alertPop } from "apiServices/common/helper";
import Header from "components/Common/Header";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import CommercialPackingRequirementForm from "../CommercialPackingRequirementForm";

export default function CommercialPackingRequirementUpdate() {
  const navigate = useNavigate();
  const id = useParams().id;

  const [commercialPackingRequirement, setCommercialPackingRequirement] =
    useState();

  function transformPackingData(input) {
    // Create the base output structure
    const output = {
      id: input.id,
      container_number: input.container_number || null,
      seal_number: input.seal_number || null,
      fedder_vessel: input.fedder_vessel || null,
      mother_vessel: input.mother_vessel || null,
      eta: input.eta || null,
      etd: input.etd || null,
      cartons: [],
    };

    // Transform each carton in the input
    if (input.cartons && input.cartons.length > 0) {
      output.cartons = input.cartons.map((carton) => ({
        id: carton.id,
        commercial_length: carton.commercial_length || null,
        commercial_width: carton.commercial_width || null,
        commercial_height: carton.commercial_height || null,
        commercial_cbm: carton.commercial_cbm || null,
        commercial_gross_weight: carton.commercial_gross_weight || null,
        commercial_net_weight: carton.commercial_net_weight || null,
      }));
    }

    return output;
  }

  const onSubmit = async () => {
    try {
      const body = transformPackingData(commercialPackingRequirement);
      console.log("body", body);

      const res = await postData(
        `${COMMERCIAL_PACKING_REQUIREMENTS}/${id}/edit`,
        body,
      );
      if (res?.code === 200) {
        alertPop("success", res?.messages);
        navigate(-1);
      } else {
        alertPop("error", res?.messages);
      }
    } catch (error) {
      alertPop("error", error?.response?.data?.messages);
    }
  };

  useEffect(() => {
    const getCommercialPackingRequirement = async () => {
      let response = await getData(
        `${COMMERCIAL_PACKING_REQUIREMENTS_EDIT}/${id}`,
        false,
      );
      if (response && response?.status === 200) {
        let masterData = response?.data;
        setCommercialPackingRequirement(masterData?.data);
      } else {
        alertPop(
          "error",
          response?.messages ? response?.messages : "Something Went Wrong!",
        );
      }
    };
    getCommercialPackingRequirement();
  }, [id]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed">
          <Header
            title="Edit Commercial Packing Requirement"
            subTitle=""
            addLink="/"
            addText="Submit"
            actions={[
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={1}
                  danger
                  onClick={() => navigate(-1)}
                >
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button size="small" key={2} type="primary" onClick={onSubmit}>
                  Update
                </Button>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <CommercialPackingRequirementForm
        mode="update"
        data={commercialPackingRequirement}
        setData={setCommercialPackingRequirement}
      />
    </>
  );
}
